import { Device, DeviceType, ParameterType } from './types';

export const mockDevices: Device[] = [
  // ============================================
  // ОСВЕЩЕНИЕ
  // ============================================
  
  // 1. Relay - Простой выключатель
  {
    id: 'device_001',
    baseName: 'Умная лампа',
    customName: 'Лампа в гостиной',
    deviceId: 'device_001',
    type: DeviceType.Relay,
    room: 'Гостиная',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      }
    ],
    rusType: 'Выключатель',
    flatId: 1,
    index: 0,
    deviceState: {
      parameterName: 'power',
      rusValueOnlyView: 'Включено',
      state: { Success: 'Success' } as any
    }
  },

  // 2. Double Relay - Двойной выключатель
  {
    id: 'device_002',
    baseName: 'Двойной выключатель',
    customName: 'Свет на кухне',
    deviceId: 'device_002',
    type: DeviceType.DoubleRelay,
    room: 'Кухня',
    isOnline: true,
    parameters: [
      { 
        id: 'power_1', 
        name: 'power_1', 
        rusName: 'Основной свет', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'power_2', 
        name: 'power_2', 
        rusName: 'Подсветка', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Выключено',
        readableValue: 'Выключено'
      }
    ],
    rusType: 'Двойной выключатель',
    flatId: 1,
    index: 1,
    deviceState: {
      parameterName: 'power_1',
      rusValueOnlyView: 'Включено',
      state: { Success: 'Success' } as any
    }
  },

  // 3. Triple Relay - Тройной выключатель
  {
    id: 'device_003',
    baseName: 'Тройной выключатель',
    customName: 'Свет в спальне',
    deviceId: 'device_003',
    type: DeviceType.TripleRelay,
    room: 'Спальня',
    isOnline: true,
    parameters: [
      { 
        id: 'power_1', 
        name: 'power_1', 
        rusName: 'Потолок', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Выключено',
        readableValue: 'Выключено'
      },
      { 
        id: 'power_2', 
        name: 'power_2', 
        rusName: 'Торшер', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'power_3', 
        name: 'power_3', 
        rusName: 'Бра', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Выключено',
        readableValue: 'Выключено'
      }
    ],
    rusType: 'Тройной выключатель',
    flatId: 1,
    index: 2,
    deviceState: null
  },

  // 4. Dimmer - Диммер
  {
    id: 'device_004',
    baseName: 'Диммер',
    customName: 'Люстра в зале',
    deviceId: 'device_004',
    type: DeviceType.Dimmer,
    room: 'Зал',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'brightness', 
        name: 'brightness', 
        rusName: 'Яркость', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 75,
        rusValueOnlyView: '75%',
        readableValue: '75%'
      }
    ],
    rusType: 'Диммер',
    flatId: 1,
    index: 3,
    deviceState: {
      parameterName: 'brightness',
      rusValueOnlyView: '75%',
      state: { Success: 'Success' } as any
    }
  },

  // 5. Double Dimmer - Двойной диммер
  {
    id: 'device_005',
    baseName: 'Двойной диммер',
    customName: 'Свет в ванной',
    deviceId: 'device_005',
    type: DeviceType.DoubleDimmer,
    room: 'Ванная',
    isOnline: true,
    parameters: [
      { 
        id: 'power_1', 
        name: 'power_1', 
        rusName: 'Основной свет', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'brightness_1', 
        name: 'brightness_1', 
        rusName: 'Яркость основного', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 100,
        rusValueOnlyView: '100%',
        readableValue: '100%'
      },
      { 
        id: 'power_2', 
        name: 'power_2', 
        rusName: 'Ночник', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'brightness_2', 
        name: 'brightness_2', 
        rusName: 'Яркость ночника', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 30,
        rusValueOnlyView: '30%',
        readableValue: '30%'
      }
    ],
    rusType: 'Двойной диммер',
    flatId: 1,
    index: 4,
    deviceState: null
  },

  // ============================================
  // КЛИМАТ
  // ============================================

  // 6. Thermostatic Radiator Valve - Термоголовка
  {
    id: 'device_006',
    baseName: 'Термоголовка',
    customName: 'Батарея в спальне',
    deviceId: 'device_006',
    type: DeviceType.ThermostaticRadiatorValve,
    room: 'Спальня',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'temperature', 
        name: 'temperature', 
        rusName: 'Температура', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 22,
        rusValueOnlyView: '22°C',
        readableValue: '22°C'
      },
      { 
        id: 'mode', 
        name: 'mode', 
        rusName: 'Режим', 
        type: ParameterType.Enum, 
        boolValue: null,
        stringValue: 'comfort',
        numericValue: null,
        rusValueOnlyView: 'Комфорт',
        readableValue: 'Комфорт'
      }
    ],
    rusType: 'Термоголовка',
    flatId: 1,
    index: 5,
    deviceState: {
      parameterName: 'temperature',
      rusValueOnlyView: '22°C',
      state: { Success: 'Success' } as any
    }
  },

  // 7. Climate Sensor - Датчик климата
  {
    id: 'device_007',
    baseName: 'Датчик климата',
    customName: 'Климат в гостиной',
    deviceId: 'device_007',
    type: DeviceType.ClimateSensor,
    room: 'Гостиная',
    isOnline: true,
    parameters: [
      { 
        id: 'temperature', 
        name: 'temperature', 
        rusName: 'Температура', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 23.5,
        rusValueOnlyView: '23.5°C',
        readableValue: '23.5°C'
      },
      { 
        id: 'humidity', 
        name: 'humidity', 
        rusName: 'Влажность', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 45,
        rusValueOnlyView: '45%',
        readableValue: '45%'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 85,
        rusValueOnlyView: '85%',
        readableValue: '85%'
      }
    ],
    rusType: 'Датчик климата',
    flatId: 1,
    index: 6,
    deviceState: {
      parameterName: 'temperature',
      rusValueOnlyView: '23.5°C',
      state: { Success: 'Success' } as any
    }
  },

  // ============================================
  // БЕЗОПАСНОСТЬ
  // ============================================

  // 8. Door Sensor - Датчик двери
  {
    id: 'device_008',
    baseName: 'Датчик двери',
    customName: 'Входная дверь',
    deviceId: 'device_008',
    type: DeviceType.DoorSensor,
    room: 'Коридор',
    isOnline: true,
    parameters: [
      { 
        id: 'state', 
        name: 'state', 
        rusName: 'Состояние', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Закрыто',
        readableValue: 'Закрыто'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 92,
        rusValueOnlyView: '92%',
        readableValue: '92%'
      }
    ],
    rusType: 'Датчик двери',
    flatId: 1,
    index: 7,
    deviceState: {
      parameterName: 'state',
      rusValueOnlyView: 'Закрыто',
      state: { Success: 'Success' } as any
    }
  },

  // 9. Motion Sensor - Датчик движения
  {
    id: 'device_009',
    baseName: 'Датчик движения',
    customName: 'Движение в коридоре',
    deviceId: 'device_009',
    type: DeviceType.MotionSensor,
    room: 'Коридор',
    isOnline: true,
    parameters: [
      { 
        id: 'motion', 
        name: 'motion', 
        rusName: 'Движение', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Нет движения',
        readableValue: 'Нет движения'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 78,
        rusValueOnlyView: '78%',
        readableValue: '78%'
      }
    ],
    rusType: 'Датчик движения',
    flatId: 1,
    index: 8,
    deviceState: null
  },

  // 10. Water Leak Sensor - Датчик протечки
  {
    id: 'device_010',
    baseName: 'Датчик протечки',
    customName: 'Протечка под раковиной',
    deviceId: 'device_010',
    type: DeviceType.WaterLeakSensor,
    room: 'Кухня',
    isOnline: true,
    parameters: [
      { 
        id: 'leak', 
        name: 'leak', 
        rusName: 'Протечка', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Нет протечки',
        readableValue: 'Нет протечки'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 95,
        rusValueOnlyView: '95%',
        readableValue: '95%'
      }
    ],
    rusType: 'Датчик протечки',
    flatId: 1,
    index: 9,
    deviceState: null
  },

  // 11. Smoke Sensor - Датчик дыма
  {
    id: 'device_011',
    baseName: 'Датчик дыма',
    customName: 'Дым на кухне',
    deviceId: 'device_011',
    type: DeviceType.SmokeSensor,
    room: 'Кухня',
    isOnline: true,
    parameters: [
      { 
        id: 'smoke', 
        name: 'smoke', 
        rusName: 'Дым', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Чисто',
        readableValue: 'Чисто'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 88,
        rusValueOnlyView: '88%',
        readableValue: '88%'
      }
    ],
    rusType: 'Датчик дыма',
    flatId: 1,
    index: 10,
    deviceState: null
  },

  // 12. Gas Sensor - Датчик газа
  {
    id: 'device_012',
    baseName: 'Датчик газа',
    customName: 'Газ на кухне',
    deviceId: 'device_012',
    type: DeviceType.GasSensor,
    room: 'Кухня',
    isOnline: true,
    parameters: [
      { 
        id: 'gas', 
        name: 'gas', 
        rusName: 'Газ', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Норма',
        readableValue: 'Норма'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 72,
        rusValueOnlyView: '72%',
        readableValue: '72%'
      }
    ],
    rusType: 'Датчик газа',
    flatId: 1,
    index: 11,
    deviceState: null
  },

  // ============================================
  // СПЕЦИАЛЬНОЕ
  // ============================================

  // 13. IR Remote Controller - ИК пульт
  {
    id: 'device_013',
    baseName: 'ИК пульт',
    customName: 'Пульт в гостиной',
    deviceId: 'device_013',
    type: DeviceType.IrRemoteController,
    room: 'Гостиная',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'mode', 
        name: 'mode', 
        rusName: 'Режим', 
        type: ParameterType.Enum, 
        boolValue: null,
        stringValue: 'tv',
        numericValue: null,
        rusValueOnlyView: 'Телевизор',
        readableValue: 'Телевизор'
      }
    ],
    rusType: 'ИК пульт',
    flatId: 1,
    index: 12,
    deviceState: null
  },

  // 14. Roller Driver - Привод штор
  {
    id: 'device_014',
    baseName: 'Привод штор',
    customName: 'Шторы в спальне',
    deviceId: 'device_014',
    type: DeviceType.RollerDriver,
    room: 'Спальня',
    isOnline: true,
    parameters: [
      { 
        id: 'position', 
        name: 'position', 
        rusName: 'Позиция', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 100,
        rusValueOnlyView: 'Открыто',
        readableValue: 'Открыто'
      },
      { 
        id: 'moving', 
        name: 'moving', 
        rusName: 'Движение', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Остановлено',
        readableValue: 'Остановлено'
      }
    ],
    rusType: 'Привод штор',
    flatId: 1,
    index: 13,
    deviceState: null
  },

  // 15. Socket - Умная розетка
  {
    id: 'device_015',
    baseName: 'Умная розетка',
    customName: 'Розетка у кровати',
    deviceId: 'device_015',
    type: DeviceType.Socket,
    room: 'Спальня',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'power_consumption', 
        name: 'power_consumption', 
        rusName: 'Потребление', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 45,
        rusValueOnlyView: '45 Вт',
        readableValue: '45 Вт'
      }
    ],
    rusType: 'Умная розетка',
    flatId: 1,
    index: 14,
    deviceState: null
  },

  // 16. Wire Device - Проводное устройство
  {
    id: 'device_016',
    baseName: 'Проводное устройство',
    customName: 'Вентилятор',
    deviceId: 'device_016',
    type: DeviceType.WireDevice,
    room: 'Ванная',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'speed', 
        name: 'speed', 
        rusName: 'Скорость', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 2,
        rusValueOnlyView: 'Средняя',
        readableValue: 'Средняя'
      }
    ],
    rusType: 'Вентилятор',
    flatId: 1,
    index: 15,
    deviceState: null
  },

  // 17. IR Device - ИК устройство (кондиционер)
  {
    id: 'device_017',
    baseName: 'Кондиционер',
    customName: 'Кондиционер в зале',
    deviceId: 'device_017',
    type: DeviceType.IrDevice,
    room: 'Зал',
    isOnline: true,
    parameters: [
      { 
        id: 'power', 
        name: 'power', 
        rusName: 'Питание', 
        type: ParameterType.Bool, 
        boolValue: true,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Включено',
        readableValue: 'Включено'
      },
      { 
        id: 'temperature', 
        name: 'temperature', 
        rusName: 'Температура', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 24,
        rusValueOnlyView: '24°C',
        readableValue: '24°C'
      },
      { 
        id: 'mode', 
        name: 'mode', 
        rusName: 'Режим', 
        type: ParameterType.Enum, 
        boolValue: null,
        stringValue: 'cool',
        numericValue: null,
        rusValueOnlyView: 'Охлаждение',
        readableValue: 'Охлаждение'
      },
      { 
        id: 'fan_speed', 
        name: 'fan_speed', 
        rusName: 'Вентилятор', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 3,
        rusValueOnlyView: 'Высокая',
        readableValue: 'Высокая'
      }
    ],
    rusType: 'Кондиционер',
    flatId: 1,
    index: 16,
    deviceState: null
  },

  // 18. Оффлайн устройство
  {
    id: 'device_018',
    baseName: 'Датчик движения',
    customName: 'Движение в подвале',
    deviceId: 'device_018',
    type: DeviceType.MotionSensor,
    room: 'Подвал',
    isOnline: false,
    parameters: [
      { 
        id: 'motion', 
        name: 'motion', 
        rusName: 'Движение', 
        type: ParameterType.Bool, 
        boolValue: false,
        stringValue: null,
        numericValue: null,
        rusValueOnlyView: 'Нет движения',
        readableValue: 'Нет движения'
      },
      { 
        id: 'battery', 
        name: 'battery', 
        rusName: 'Батарея', 
        type: ParameterType.Numeric, 
        boolValue: null,
        stringValue: null,
        numericValue: 15,
        rusValueOnlyView: '15%',
        readableValue: '15%'
      }
    ],
    rusType: 'Датчик движения',
    flatId: 1,
    index: 17,
    deviceState: null
  }
];

// Mock скрипты автоматизации
export const mockScripts = [
  {
    id: 'script_001',
    actionId: 'script_001',
    name: 'Утренний свет',
    type: 'device_trigger' as any,
    isActive: true,
    ifDevices: [
      {
        id: 'if_001',
        deviceId: 'device_009',
        deviceName: 'Движение в коридоре',
        deviceType: DeviceType.MotionSensor,
        room: 'Коридор',
        params: {
          comparison: 'EQUALS' as any,
          parameterName: 'motion',
          stringValue: 'true',
          typeAction: 'device_condition' as any,
          paramType: ParameterType.Bool,
        }
      }
    ],
    thenDevices: [
      {
        id: 'then_001',
        deviceId: 'device_001',
        deviceName: 'Лампа в гостиной',
        deviceType: DeviceType.Relay,
        room: 'Гостиная',
        params: {
          parameterName: 'power',
          stringValue: 'true',
          typeAction: 'zigbee_action' as any,
          paramType: ParameterType.Bool,
        }
      }
    ],
    flatId: 1,
    conditionType: 'and_condition' as any,
    groupDeviceId: 'group_001',
    groupName: 'Автоматизация'
  },
  {
    id: 'script_002',
    actionId: 'script_002',
    name: 'Ночной режим',
    type: 'device_trigger' as any,
    isActive: true,
    ifDevices: [
      {
        id: 'if_002',
        deviceId: 'device_008',
        deviceName: 'Входная дверь',
        deviceType: DeviceType.DoorSensor,
        room: 'Коридор',
        params: {
          comparison: 'EQUALS' as any,
          parameterName: 'state',
          stringValue: 'true',
          typeAction: 'device_condition' as any,
          paramType: ParameterType.Bool,
        }
      }
    ],
    thenDevices: [
      {
        id: 'then_002',
        deviceId: 'device_015',
        deviceName: 'Розетка у кровати',
        deviceType: DeviceType.Socket,
        room: 'Спальня',
        params: {
          parameterName: 'power',
          stringValue: 'false',
          typeAction: 'zigbee_action' as any,
          paramType: ParameterType.Bool,
        }
      }
    ],
    flatId: 1,
    conditionType: 'and_condition' as any,
    groupDeviceId: 'group_001',
    groupName: 'Автоматизация'
  },
  {
    id: 'script_003',
    actionId: 'script_003',
    name: 'Климат контроль',
    type: 'device_trigger' as any,
    isActive: false,
    ifDevices: [
      {
        id: 'if_003',
        deviceId: 'device_007',
        deviceName: 'Климат в гостиной',
        deviceType: DeviceType.ClimateSensor,
        room: 'Гостиная',
        params: {
          comparison: 'MORE' as any,
          parameterName: 'temperature',
          numericValue: 25,
          typeAction: 'device_condition' as any,
          paramType: ParameterType.Numeric,
        }
      }
    ],
    thenDevices: [
      {
        id: 'then_003',
        deviceId: 'device_017',
        deviceName: 'Кондиционер в зале',
        deviceType: DeviceType.IrDevice,
        room: 'Зал',
        params: {
          parameterName: 'power',
          stringValue: 'true',
          typeAction: 'zigbee_action' as any,
          paramType: ParameterType.Bool,
        }
      }
    ],
    flatId: 1,
    conditionType: 'and_condition' as any,
    groupDeviceId: 'group_001',
    groupName: 'Автоматизация'
  }
];

// Mock комнаты
export const mockRooms = [
  { id: 1, title: 'Гостиная' },
  { id: 2, title: 'Спальня' },
  { id: 3, title: 'Кухня' },
  { id: 4, title: 'Ванная' },
  { id: 5, title: 'Коридор' },
  { id: 6, title: 'Зал' },
  { id: 7, title: 'Подвал' },
];

// Mock статистика устройства
export const mockDeviceStatistics = {
  temperature: generateStatisticsData(20, 25, 24),  // 20-25°C
  humidity: generateStatisticsData(40, 60, 45),      // 40-60%
  power: generateStatisticsData(0, 100, 45),         // 0-100 Вт
  brightness: generateStatisticsData(0, 100, 75),    // 0-100%
};

function generateStatisticsData(min: number, max: number, current: number) {
  const data = [];
  const now = new Date();
  
  for (let i = 23; i >= 0; i--) {
    const timestamp = new Date(now.getTime() - i * 60 * 60 * 1000);
    const value = current + (Math.random() - 0.5) * (max - min) * 0.5;
    data.push({
      timestamp: timestamp.toISOString(),
      value: Math.round(value * 10) / 10,
    });
  }
  
  return data;
}
